var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-input',{staticClass:"inputx w-full",attrs:{"label":"Guests","placeholder":"Number of seats","type":"number","disabled":_vm.disableComponent},model:{value:(_vm.selectedGuestCount),callback:function ($$v) {_vm.selectedGuestCount=$$v},expression:"selectedGuestCount"}})
}
var staticRenderFns = []

export { render, staticRenderFns }